<template>
  <section>
    <h1 class="section-head">สิทธิ์การเข้าถึง</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <router-link class="button is-success" :to="'/permission/add/0'"><i class="fas fa-plus"></i> เพิ่ม</router-link>
          </div>
        </div>
      </div>
    </nav>
    
    <div>
      <div v-for="permission in parentPermFilteredComputed" v-bind:key="permission.id">
        <h3 class="section-mini-head">{{permission.name}} <!--<button class="button is-success is-tiny" @click="openPermissionModal(permission.id,permission.name)"><i class="fas fa-plus"></i> เพิ่ม</button> --> <router-link class="button is-success is-tiny" :to="'/permission/add/' + permission.id"><i class="fas fa-plus"></i> เพิ่ม</router-link></h3>
        <div class="block has-background-lightgray has-padding-5" >
          <b-tag
            v-for="sub_permission in childPermFiltered(permission.id)"
            v-bind:key="sub_permission.id"
            class="child-item"
            >
              {{sub_permission.name}}=> <strong>{{sub_permission.slug}}</strong>
          </b-tag>
          <div class="notification has-text-centered" v-if="childPermFiltered(permission.id).length == 0 && !isTableLoading">ไม่พบข้อมูล</div>
        </div>
      </div>

      <b-modal :active.sync="isComponentModalActive" >
          <modal-permission-form v-bind="formProps"></modal-permission-form>
      </b-modal>
      <b-loading :is-full-page="false" :active.sync="isLoading" :canCancel="false"></b-loading>
    </div>
  </section>
</template>

<script>
  import Request from '@/libraries/request'
  import UserModel from '@/model/user_model'
  import PermissionModel from '@/model/permission_model'

  const ModalPermissionForm = {
        props: ['id', 'name', 'slug', 'parent_id', 'parent_name','submitPermision'],
        template: `
            <form action="">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Add Permission</p>
                    </header>
                    <section class="modal-card-body">
                      <b-field label="Parent">
                          <b-input
                              type="text"
                              :value="parent_name"
                              placeholder="Parent"
                              disabled
                              >
                          </b-input>
                      </b-field>

                      <b-field label="Name">
                          <b-input
                              type="text"
                              :value="name"
                              placeholder="Permission name"
                              >
                          </b-input>
                      </b-field>

                      <b-field label="Slug">
                          <b-input
                              type="text"
                              :value="slug"
                              placeholder="Permission slug"
                              >
                          </b-input>
                      </b-field>

                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="$parent.close()">Close</button>
                        <button class="button is-primary" type="button" @click="submitPermision(id,name,slug,parent_id)">Save</button>
                    </footer>
                </div>
            </form>
        `
    }

  export default {
    name: 'Permission_index',
    components: {
        ModalPermissionForm
    },
    data() {
      return {
        permissions: [],
        isTableLoading: true,
        isComponentModalActive: false,
        formProps: {
            id: null,
            name: '',
            slug: '',
            parent_id: 0,
            parent_name: "",
            permissions: [],
            submitPermision: null,
        },
        isLoading: true,
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      parentPermFilteredComputed() {
        return this.permissions.filter(perm => {
          if(perm.parent_id == 0){
            return perm;
          }
        });
      },
    },
    methods: {
      async init(){
        this.permissions = await PermissionModel.get_permissions();
        this.isTableLoading = false;
        this.isLoading = false;
      },
      childPermFiltered(id) {
        return this.permissions.filter(perm => {
          if(perm.parent_id == id){
            return perm;
          }
        });
      },
      parentPermFiltered() {
        return this.permissions.filter(perm => {
          if(perm.parent_id == 0){
            return perm;
          }
        });
      },
      openPermissionModal(parent_id,parent_name) {
        if(parent_id){
          this.formProps.parent_id = parent_id;
          this.formProps.parent_name = parent_name;
          this.formProps.submitPermision = this.submitPermision;
          this.isComponentModalActive = true;

        }
      },
      submitPermision(id,name,slug,parent_id){
        this.isLoading = true;
        
        let data = {
          id: id,
          name: name,
          slug: slug,
          parent_id: parent_id,
        }

        Request.post('permissions/add',data, (res) => {
          if(res.data.status){
            this.permissions = res.data.data;
            this.isLoading = false;
            this.$buefy.snackbar.open('บันทึกสำเร็จ!');
          }else{
            this.$buefy.toast.open('ไม่สามารถบันทึกได้! - ' + res.data.msg);
          }
        });

        this.isLoading = false;
      }
    }
  }
</script>

<style scoped>
.child-item {
  margin: 0.2rem;
}

.is-tiny {
  border-radius: 2px;
  font-size: 0.7rem;
  height: 1.5rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/Permission/index.vue